import { useLayoutEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import ScrollToTop from "@/components/atomic/ScrollToTop";
import { DeepAnalysisModal } from "@/components/ui/DeepAnalysisModal";
import { Header } from "@/components/ui/Header";
import { Sidebar } from "@/components/ui/Sidebar";
import { AppContextProvider } from "@/contexts/AppContext";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { cn } from "@/lib/utils";

const OutletWrapper = ({ children }: { children: React.ReactNode; }) => {
  return (
    <div
      className={cn(
        "flex flex-col w-full transition-width duration-200 ease-in-out overflow-auto",
      )}
    >
      {children}
    </div>
  );
};

const VoiceekLayout: React.FC = () => {
  const { workspaceId } = useParams();
  const { setWorkspaceId } = useWorkspaces();

  // URLにあるworkspaceIdをlocalStorageとsessionStorageに保存する
  useLayoutEffect(() => {
    if (!workspaceId) return;
    setWorkspaceId(workspaceId);
  }, [workspaceId, setWorkspaceId]);

  return (
    <AppContextProvider>
      <ScrollToTop />
      <div className="flex flex-col justify-center w-full h-dvh">
        <Header />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <OutletWrapper>
            <Outlet />
          </OutletWrapper>
        </div>
      </div>
      <DeepAnalysisModal />
    </AppContextProvider>
  );
};

export default VoiceekLayout;
